import React from 'react';
import { shape, string } from 'prop-types';
import { useStyle } from '../../classify';
import Shimmer from '../Shimmer';
import defaultClasses from './filterModalOpenButton.shimmer.module.css';

var FilterModalOpenButtonShimmer = function FilterModalOpenButtonShimmer(props) {
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement(Shimmer, {
    classes: {
      root_button: classes.filterButtonShimmer
    },
    type: "button",
    "aria-live": "polite",
    "aria-busy": "true"
  });
};

FilterModalOpenButtonShimmer.propTypes = {
  classes: shape({
    filterButtonShimmer: string
  })
};
export default FilterModalOpenButtonShimmer;